// @flow

import styles from './Popup.module.css';

export const Popup = ({ show, closePopup, children }) => {
  if (show) {
    document.body.style.overflowY = 'hidden';
  } else document.body.style.overflowY = 'auto';

  return (
    <div className={`${styles.Popup} ${show ? styles.Show : ''}`} onClick={() => closePopup(false)}>
      <div
        className={`${styles.PopupWrapper} ${show ? styles.Show : ''}`}
        onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
};
